
import React, { useState, createContext, useContext } from "react";

const MapFormContext = createContext();

export const MapFormProvider = ({ children, initialData = {} }) => {
  const [sharedState, setSharedState] = useState({
    latitude: initialData.latitude || 33.6844,
    longitude: initialData.longitude || 73.0479,
    area: initialData.area || 1.0,
    crop_type: initialData.crop_type || "wheat",
    planting_date:
      initialData.planting_date || new Date().toISOString().split("T")[0],
    

    detectedProvince: initialData.detectedProvince || null,
    selectedProvince: initialData.selectedProvince || '',
    
    mapActions: null,
    formData: null,
    isLoading: false,
    error: null,
    formKey: Date.now(),
    irrigationResults: null,
    irrigationScenarioType: null,
    ...initialData,
  });

  const updateSharedState = (updates) => {
    setSharedState((prev) => ({ ...prev, ...updates }));
  };


  const handleLocationChange = (latitude, longitude, province) => {
    updateSharedState({ 
      latitude, 
      longitude, 
      detectedProvince: province 
    });
  };

  const handleCropInfoChange = (crop_type, area, planting_date) => {
    updateSharedState({ crop_type, area, planting_date });
  };

  const handleDataReceived = (data) => {
    updateSharedState({
      formData: data,
      formKey: Date.now(),
    });
  };

  const handleMapReady = (actions) => {
    updateSharedState({ mapActions: actions });
  };

  const handleIrrigationResults = (scenarioType, results) => {
    updateSharedState({
      irrigationResults: results,
      irrigationScenarioType: scenarioType,
    });
  };


  const setSelectedProvince = (province) => {
    updateSharedState({ selectedProvince: province });
  };

  const getEffectiveProvince = () => {
    return sharedState.selectedProvince || sharedState.detectedProvince || null;
  };

  const resetProvinceSelection = () => {
    updateSharedState({ selectedProvince: '' });
  };

  const contextValue = {

    ...sharedState,
    

    updateSharedState,
    handleLocationChange,
    handleCropInfoChange,
    handleDataReceived,
    handleMapReady,
    handleIrrigationResults,
    

    setSelectedProvince,
    getEffectiveProvince,
    resetProvinceSelection,
  };

  return (
    <MapFormContext.Provider value={contextValue}>
      {children}
    </MapFormContext.Provider>
  );
};

export const useMapForm = () => {
  const context = useContext(MapFormContext);
  if (!context) {
    throw new Error("useMapForm must be used within a MapFormProvider");
  }
  return context;
};
